module.exports = __webpack_public_path__ + "img/mato_grosso_do_sul.6e28221e.jpg";